/**
 * Auto-registers all components matching the pattern.
 * Works in both Webpack (Production/Dev) and Vite (Playwright).
 */
export function initializeRegistry() {
  // 1. Vite / ESM Environment
  // @ts-expect-error This is preparation for VITE
  if (import.meta && import.meta.glob) {
    // { eager: true } is critical so the code executes immediately
    // @ts-expect-error This is preparation for VITE
    import.meta.glob('./**/*.autoload.{ts,tsx}', { eager: true });
    return;
  }

  // 2. Webpack Environment
  if ((import.meta as any).webpackContext) {
    const context = (import.meta as any).webpackContext('.', {
      recursive: true,
      regExp: /\.autoload\.tsx?$/,
    });
    context.keys().forEach(context);
  }
}
